import axios from 'axios';
import {actions} from '../reducers/NotificationsTableReducer';
import {GetListParams, NotificationsForExcelResponseBody, NotificationsResponseBody} from "../types";
import {Dispatch} from "redux";
import {ApiResponse} from "../../_common/types";

export const GET_NOTIFICATIONS = 'notifications/getList';
export const GET_NOTIFICATIONS_EXCEL = 'notifications/getListForExcel';
export const GET_NOTIFICATIONS_SUBJECTS = 'notifications/getNotificationsSubjects';

export const getList = (action: (payload: any) => any) => (params: GetListParams = {}) =>
  async (dispatch: Dispatch) => {
    const {
      fromDate = '',
      toDate = '',
      docID = '',
      subjectID = -1,
      statusID = -1,
      requestedPageNumber = 0,
      sortByField = 'sentAt',
      sortByOrder = -1
    } = params;

    const data = {
      fromDate,
      toDate,
      docID,
      subjectID: parseInt(String(subjectID), 10),
      statusID: parseInt(String(statusID), 10),
      requestedPageNumber: parseInt(String(requestedPageNumber), 10),
      sortByField,
      sortByOrder
    };
    try {
      const response = await axios.post<ApiResponse<NotificationsResponseBody>>(GET_NOTIFICATIONS, data);
      const {errorCode, body} = response.data;

      if (errorCode < 0) {
        throw new Error("API error");
      }

      const {totalPageCount, currentPageNumber, list, totalResultCount} = body;

      dispatch(
        action({
          totalPageCount,
          currentPageNumber,
          list,
          totalResultCount,
        })
      );
    } catch (error: any) {
      error.clientMessage = "Can't find data";
      dispatch(actions.catchError(error));
    }
  };

export const getListForExcel = (params: GetListParams = {}) => async (dispatch: Dispatch) => {
  const {
    fromDate = '',
    toDate = '',
    docID = '',
    subjectID = -1,
    statusID = -1,
    sortByField = 'sentAt',
    sortByOrder = -1,
  } = params;

  const data = {
    fromDate,
    toDate,
    docID,
    subjectID: parseInt(String(subjectID), 10),
    statusID: parseInt(String(statusID), 10),
    sortByField,
    sortByOrder,
  };

  try {
    const response = await axios.post<ApiResponse<NotificationsForExcelResponseBody>>(
      GET_NOTIFICATIONS_EXCEL,
      data
    );

    const {errorCode, body} = response.data;

    if (errorCode < 0) {
      throw new Error('API error');
    }

    return body?.list ?? [];
  } catch (error: unknown) {
    (error as Error & { clientMessage?: string }).clientMessage = "Can't find data";
    dispatch(actions.catchError(error as string));
  }
};

export const getNotifications = getList(actions.notificationsFetched);
export const getNextNotifications = getList(actions.notificationsAppended);

export const getNotificationsSubjects = async () => {
  const response = await axios.get(GET_NOTIFICATIONS_SUBJECTS);
  const {errorCode, body} = response.data;
  if (errorCode < 0) {
    throw new Error();
  } else {
    return body?.notificationsSubjects ?? [];
  }
};